import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import type {
  BookmarkType,
  BookmarksPaginationResponse,
} from "@circle-react/types/Bookmarks";
import { infiniteQueryOptions } from "react-query";

export const bookmarkKey = createQueryKeyFactory("bookmark");

export const bookmarkQueries = {
  list: (bookmarkType?: BookmarkType) =>
    infiniteQueryOptions({
      getNextPageParam: lastPage =>
        lastPage.has_next_page ? lastPage.page + 1 : undefined,
      initialPageParam: 1,
      queryKey: bookmarkKey.key("list", bookmarkType ?? "all"),
      queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
        reactQueryGet<BookmarksPaginationResponse>(
          internalApi.bookmarks.index({
            params: {
              page: pageParam,
              ...(bookmarkType && { bookmark_type: bookmarkType }),
            },
          }),
        ),
    }),
};

export const bookmarkInvalidations = {
  all: () => queryClient.invalidateQueries({ queryKey: bookmarkKey.root() }),
  list: (bookmarkType?: BookmarkType) =>
    queryClient.invalidateQueries({
      queryKey: bookmarkQueries.list(bookmarkType).queryKey,
    }),
};
